export const FIELD_NODE = 'field_node';
export const BLOCK_NODE = 'block_node';
export const ROOT_NODE = 'root';
